export const pageConstatns = {
  backendStack: "back",
  frontEndStack: "front",
};

export const aboutMe = {
  description: `<span class="page__container"> 
    <div class="aboutMe__profile-description--text"> Hello! :)</div>
    <div class="aboutMe__profile-description--text"> Welcome on my portfolio, on the current page you will find out more things about me.</div>
    <div class="aboutMe__profile-description--text"> I am a <span class="description__title">JavaScript/Front-End Developer</span>  from Suceava, Romania that started building pieces of software since 2018.  </div>
    <div class="aboutMe__profile-description--text"> I love discovering new things, always in search of ways in how to optimize, improve and write better <span class="description__title">code</span>.</div>
    <div class="aboutMe__profile-description--text"> If you want to get in touch with me, you can do it on the <span class="description__title">contact page</span>. </div>
  </span>`,
};
